import { OptionKV } from "~styled/selector/Selector";

const TODOS = "";
export const PRENDARIOS = "Prendarios";
export const MERCADOABIERTO = "MercadoAbierto";

const negociosOptions: Record<string, string> = {
  [TODOS]: "Todos",
  [PRENDARIOS]: "Prendarios",
  [MERCADOABIERTO]: "Mercado Abierto",
};

const negocios: string[] = [PRENDARIOS, MERCADOABIERTO];

const negociosFilter: OptionKV<string>[] = [
  { label: negociosOptions[TODOS], value: TODOS },
  {
    label: negociosOptions[PRENDARIOS],
    value: PRENDARIOS,
  },
  {
    label: negociosOptions[MERCADOABIERTO],
    value: MERCADOABIERTO,
  },
];

export { negociosOptions, negocios, negociosFilter };
